import React from 'react';
import {
    LoadingContainer,
    LoadingSpinner,
    LoadingText
} from './styled';

const SubscriptionLoading = ({ message = "Verificando sua assinatura..." }) => {
    return (
        <LoadingContainer>
            <LoadingSpinner />
            <LoadingText>{message}</LoadingText>
        </LoadingContainer>
    );
};

export default SubscriptionLoading;
